import { Divider } from 'antd';
import { useState } from 'react';
import DotPhraseAdminSource from './DotPhraseAdminSource.page';
import DotPhraseAdminTarget from './DotPhraseAdminTarget.page';

const DotPhraseAdminPage = () => {
  const [selectedDotPhrasesDataSource, setSelectedDotPhrasesDataSource] =
    useState([]);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const handleRefresh = () => {
    setRefreshTrigger((prev) => prev + 1);
  };

  return (
    <div className="flex flex-row pt-4 min-h-screen">
      <DotPhraseAdminSource
        setSelectedDotPhrasesDataSource={setSelectedDotPhrasesDataSource}
        selectedDotPhrasesDataSource={selectedDotPhrasesDataSource}
        refreshTrigger={refreshTrigger}
      />
      <Divider
        type="vertical"
        style={{
          height: 'auto',
          margin: '0 16px',
          borderColor: '#00D090',
          borderWidth: '0.5px',
        }}
      />
      <DotPhraseAdminTarget
        selectedDotPhrasesDataSource={selectedDotPhrasesDataSource}
        onSuccessfulPush={handleRefresh}
      />
    </div>
  );
};

export default DotPhraseAdminPage;
